module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1035-e72dcdd769c5077335ea11da751dabec.png";